import Button from "components/Button";
import Modal from "components/Modal";
import React from "react";
import ArrowLeft from "icons/arrow-circle-left-green.svg";
import Confirm from "icons/confirm-circle-white.svg";
import { DeactivateMember } from "services/manageFamilies";
import toastMessage from "helpers/handleToastMessage";

type Props = {
  memberId: string;
  setMemberId: React.Dispatch<React.SetStateAction<string>>;
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  groupId: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  active: boolean;
  rechargeMembers: () => void;
};

const ChangeStatusModal: React.FC<Props> = ({
  memberId,
  setMemberId,
  show,
  setShow,
  groupId,
  setLoading,
  active,
  rechargeMembers,
}): JSX.Element => {
  const changeStatus = async () => {
    if (!memberId) {
      return;
    }
    try {
      setLoading(true);
      const { data } = await DeactivateMember(groupId, memberId, active);

      toastMessage({
        message: "Updated the status of the current!",
        type: "success",
      });

      if (data) {
        setMemberId("");
        rechargeMembers();
      }
    } catch (error: any) {
      toastMessage({
        message: "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      setMemberId("");
      setLoading(false);
      setShow(false);
    }
  };

  return (
    <Modal
      show={show}
      children={
        <div className="w-full h-44 bg-bt-white p-6 rounded-md">
          <div className="flex flex-row items-center justify-center">
            <span className="font-nunito font-light text-xl text-bt-black">
              {active
                ? "Do you really want to activate the current family member?"
                : "Do you really want to deactivate for the current family member?"}
            </span>
          </div>
          <div className="flex flex-row justify-around mt-10 mb-10">
            <div className="flex flex-col">
              <Button
                label={"Back"}
                iconLeft={ArrowLeft}
                className="bg-bt-white text-bt-green border border-bt-green h-10 w-28 font-sora rounded-full"
                onClick={() => {
                  setMemberId("");
                  setShow(false);
                }}
              />
            </div>
            <div className="flex flex-col">
              <Button
                label={"Confirm"}
                iconLeft={Confirm}
                className="bg-bt-green text-bt-white h-10 w-28 font-sora rounded-full"
                onClick={() => changeStatus()}
              />
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ChangeStatusModal;
